import PageMenu from '../../../components/pageMenu/pageMenu';
import Personals from "./personals";
import Company from "./company";
import Customers from './customers';
import Password from './password';
import DeleteAccount from './deleteAccount';
import './settings.css';

function Settings() {
    const items = [
        { key: 'personals', label: 'Persönliche Informationen', component: () => <Personals /> },
        { key: 'company', label: 'Firmeninformationen', component: () => <Company /> },
        { key: 'customer', label: 'Kunden- und Rechnungsinformationen', component: () => <Customers /> },
        { key: 'password', label: 'Passwort ändern', component: () => <Password /> },
        { key: 'deleteAccount', label: 'Account löschen', component: () => <DeleteAccount /> }
    ];

    return <PageMenu items={items} defaultActive="personals" title="Einstellungen" />;
}

export default Settings;